import { SelectOption } from "./Select";
import SearchInput from "./SearchInput";
import Tags from "@/components/Tags";
import Tooltip from "@/components/Tooltip";

interface SearchSelectSingleProps {
  label: string;
  placeholder?: string;
  reloadPropName: string;
  queryParam?: string;
  errors?: string;
  minChars?: number;
  value: SelectOption | null;
  onChange: (item: SelectOption | null) => void;
  singleSelectionMessage?: string;
}

const SearchSelectSingle: React.FC<SearchSelectSingleProps> = ({
  label,
  placeholder = "Search...",
  reloadPropName,
  queryParam,
  errors,
  minChars,
  value,
  onChange,
  singleSelectionMessage = "Only one item can be selected. Remove the current selection to choose another.",
}) => {
  const searchInput = (
    <SearchInput
      label={label}
      placeholder={placeholder}
      reloadPropName={reloadPropName}
      queryParam={queryParam}
      errors={errors}
      minChars={minChars}
      onSelect={onChange}
      selectedValues={value ? [value.value] : []}
      disabled={value !== null}
    />
  );

  return (
    <div className="flex w-full flex-col gap-2">
      {value ? (
        <Tooltip content={singleSelectionMessage}>
          <div>{searchInput}</div>
        </Tooltip>
      ) : (
        searchInput
      )}
      {value && <Tags tags={[value.label]} onRemove={() => onChange(null)} />}
    </div>
  );
};

export default SearchSelectSingle;
